module.exports = __webpack_public_path__ + "img/print_cover_a.c8a2fb07.png";